module.exports = __webpack_public_path__ + "img/1492722620.a6ac994c.jpg";